import { createFeatureSelector } from '@ngrx/store';

import { UserHistoryModuleState, userHistoryFeatureName } from '@user-history/store/state/user-history-module.state';

export const userHistoryRootSelector = createFeatureSelector<UserHistoryModuleState>(userHistoryFeatureName);

